
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donations",
      function () {
        return require("private-next-pages/donations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donations"])
      });
    }
  